exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".old-browser{width:360px;margin:0 auto;border:1px solid #ccc;padding:5px 15px;border-radius:4px;margin-top:30px}.old-browser__browsers,.old-browser__content{text-align:center}.old-browser__browsers{display:inline-block}.old-browser__browser-link{float:left;width:109px;height:20px;padding:106px 0 13px;border-radius:4px;color:#2b587a;text-decoration:none;cursor:pointer}.old-browser__browsers .firefox{background:url(" + require("../images/browsers/firefox.png") + ") no-repeat 50% 17px}.old-browser__browsers .chrome{background:url(" + require("../images/browsers/chrome.png") + ") no-repeat 50% 17px}.old-browser__browsers .opera{background:url(" + require("../images/browsers/opera.png") + ") no-repeat 50% 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!./styles/old-browsers.css
// module id = 793
// module chunks = 0